module.exports = __webpack_public_path__ + "static/media/email2.31bc9d17.svg";